import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserManagement = ({ authUser }) => {
  const [newUsername, setNewUsername] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newIsAdmin, setNewIsAdmin] = useState(false);
  const [createMsg, setCreateMsg] = useState('');
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  const loadUsers = async () => {
    if (!authUser?.is_admin) return;
    setUsersLoading(true);
    try {
      const res = await axios.get('/api/users');
      setUsers(res.data || []);
    } catch {
      // ignore
    }
    setUsersLoading(false);
  };

  const createUser = async (e) => {
    e.preventDefault();
    setCreateMsg('');
    try {
      await axios.post('/api/users', { username: newUsername, email: newEmail, password: newPassword, is_admin: newIsAdmin });
      setCreateMsg('User created');
      setNewUsername('');
      setNewEmail('');
      setNewPassword('');
      setNewIsAdmin(false);
      loadUsers();
    } catch (err) {
      setCreateMsg(err.response?.data?.error || 'Failed to create user');
    }
  };

  const updateUser = async (id, data) => {
    try {
      await axios.patch(`/api/users/${id}`, data);
      loadUsers();
    } catch {/* noop */}
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    try {
      await axios.delete(`/api/users/${id}`);
      loadUsers();
    } catch {/* noop */}
  };

  const setMaster = async (id) => {
    try {
      await axios.post(`/api/users/${id}/select_master_query`);
      loadUsers();
    } catch {/* noop */}
  };

  useEffect(() => {
    if (authUser?.is_admin) {
      loadUsers();
    }
    // eslint-disable-next-line
  }, [authUser]);

  if (!authUser?.is_admin) {
    return <div className="alert alert-warning">Admin access required.</div>;
  }

  return (
    <div className="mt-3">
      <h3>Create User</h3>
      <form className="row g-3" onSubmit={createUser}>
        <div className="col-md-3">
          <label className="form-label">Username</label>
          <input 
            className="form-control" 
            value={newUsername} 
            onChange={e=>setNewUsername(e.target.value)} 
            required 
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Email</label>
          <input 
            className="form-control" 
            type="email"
            value={newEmail} 
            onChange={e=>setNewEmail(e.target.value)} 
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Password</label>
          <input 
            className="form-control" 
            type="password" 
            value={newPassword} 
            onChange={e=>setNewPassword(e.target.value)} 
            required 
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <div className="form-check">
            <input 
              className="form-check-input" 
              type="checkbox" 
              id="newIsAdmin" 
              checked={newIsAdmin} 
              onChange={e=>setNewIsAdmin(e.target.checked)} 
            />
            <label className="form-check-label" htmlFor="newIsAdmin">Admin</label>
          </div>
        </div>
        <div className="col-12">
          <button className="btn btn-success" type="submit">Create</button>
        </div>
      </form>
      {createMsg && <div className="mt-2 alert alert-success py-2 mb-0">{createMsg}</div>}
      <hr className="my-4" />
      <h4>Users</h4>
      <div className="table-responsive">
        <table className="table table-striped table-sm align-middle">
          <thead>
            <tr>
              <th className="admin-table-width-80">ID</th>
              <th>Username</th>
              <th>Email</th>
              <th className="admin-table-width-120">Role</th>
              <th className="admin-table-width-120">Subscribed</th>
              <th className="admin-table-width-120">Master Queries</th>
              <th className="admin-table-width-200">Actions</th>
            </tr>
          </thead>
          <tbody>
            {usersLoading ? (
              <tr><td colSpan="7">Loading...</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan="7">No users found</td></tr>
            ) : (
              users.map(u => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>
                    <input className="form-control form-control-sm" defaultValue={u.username} onBlur={e=>updateUser(u.id,{ username: e.target.value })} />
                  </td>
                  <td>
                    <input className="form-control form-control-sm" type="email" defaultValue={u.email || ''} onBlur={e=>updateUser(u.id,{ email: e.target.value })} />
                  </td>
                  <td>{u.is_admin ? 'Admin' : 'User'}</td>
                  <td>
                    <input type="checkbox" className="form-check-input" checked={!!u.is_subscribed} onChange={e=>updateUser(u.id,{ is_subscribed: e.target.checked })} />
                  </td>
                  <td>
                    <input type="radio" name="masterQueryUser" className="form-check-input" checked={!!u.master_query} onChange={()=>setMaster(u.id)} />
                  </td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={()=>{
                      const p = window.prompt('New password for '+u.username+':');
                      if (p) updateUser(u.id,{ password: p });
                    }}>Set Password</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>deleteUser(u.id)}>Delete</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagement;